/* eslint-disable jsx-a11y/alt-text */
import {
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  useMediaQuery,
} from '@mui/material';
import HomeLayout from 'layouts/home';
import { useEffect, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import './index.css';
import Content from './content';
import bgimage from './bg-min.png';
import logo from './logo.svg';
import { Link, useHistory } from 'react-router-dom';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import DiscordCircleSVG from './discord-circ.svg';
import { Box } from '@mui/system';
const HomePage = () => {
  const [toc_active, setTocActive] = useState(0);
  const history = useHistory();
  // const tocs = [
  //   { href: 'intro', text: 'Introduction' },
  //   { href: 'policy', text: 'Open Source Policy' },
  //   { href: 'registration', text: 'Registration' },
  //   { href: 'timeline', text: 'Timeline' },
  //   { href: 'tracks', text: 'Challenge Tracks' },
  //   // { href: 'submission', text: 'submission' },
  //   { href: 'eval', text: 'Evaluation' },
  //   { href: 'awards', text: 'Awards' },
  //   { href: 'organizers', text: 'Organizing Committee' },
  //   { href: 'sponsor', text: 'Sponsor' },

  //   { href: 'contact', text: 'Contact' },
  // ];
  const tocs = [
    { href: 'intro', text: 'Welcome' },
    { href: 'getting-started', text: 'Getting Started' },
    { href: 'features', text: 'Features' },
    { href: 'tracks', text: 'Challenge Tracks' },
    { href: 'awards', text: 'Awards' },
    { href: 'timeline', text: 'Timeline' },
    { href: 'teams', text: 'Team Formation' },
    { href: 'evaluation', text: 'Evaluation' },
    { href: 'tasks', text: 'Tasks' },
    { href: 'resources', text: 'Resources/Tutorials' },
    { href: 'maniskill2021', text: 'ManiSkill 2021' },
    { href: 'organizers', text: 'Organizers' },
    { href: 'contributors', text: 'Contributors' },
    { href: 'citation', text: 'Citation' },
    { href: 'contact', text: 'Contact Us' },
  ];
  // const ccc = Content();
  function isInViewport(element: any) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 20 &&
      rect.left >= 0 &&
      // rect.bottom <=
      //   (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  useEffect(() => {
    const h2s = document.getElementsByClassName('anchor');
    document.addEventListener(
      'scroll',
      () => {
        for (let i = 0; i < h2s.length - 1; i++) {
          const h2 = h2s[i + 1];
          if (isInViewport(h2)) {
            setTocActive(i);
            break;
          }
        }
      },
      {
        passive: true,
      }
    );
  }, []);
  const smallSize = useMediaQuery('(max-width: 768px)');
  return (
    <HomeLayout>
      <div className="HomePage">
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={12}>
            <div className="banner">
              <img
                className="banner-image"
                // style={{
                //   backgroundImage: `url(${
                //     process.env.PUBLIC_URL + '/environments.jpg'
                //   })`,
                // }}
                src={bgimage}
              />
              <div className="banner-content">
                <Grid container>
                  {!smallSize && <Grid item xs={2}></Grid>}
                  <Grid item xs={smallSize ? 12 : 10}>
                    <div className="banner-text">
                      <img src={logo} /> <br />
                      CHALLENGE
                    </div>
                    <div className="banner-register">
                      <Box sx={{ display: 'inline-block' }}>
                        <HashLink to="#getting-started">
                          <Button variant="contained" sx={{ width: '8rem' }}>
                            Get Started
                          </Button>
                        </HashLink>
                        <div style={{textAlign:"center", marginTop: "1rem", display: "flex", justifyContent: "space-between", padding: "0 1rem"}}>
                      <Box sx={{ display: 'inline-block', backgroundColor: '#1565c0',boxShadow: '4', borderRadius: '50%'}}>
                        <a
                          href="https://github.com/haosulab/ManiSkill2"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconButton style={{color: 'white'}}>
                            <GitHubIcon sx={{ fontSize: "2rem"}}/>
                          </IconButton>
                        </a>
                      </Box>
                      <Box sx={{  display: 'inline-block', backgroundColor: '#1565c0', boxShadow: '4', borderRadius: '50%'}}>
                        <a
                          href="https://discord.gg/x8yUZe5AdN"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconButton style={{color: 'white'}}>
                            <img src={DiscordCircleSVG}  style={{width: "2rem"}}className="logo" alt="logo" />
                          </IconButton>
                        </a>
                      </Box>
                      <Box sx={{  display: 'inline-block', backgroundColor: '#1565c0',boxShadow: '4', borderRadius: '50%'}}>
                        <a
                          href="https://twitter.com/HaoSuLabUCSD"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <IconButton style={{color: 'white'}}>
                            <TwitterIcon sx={{ fontSize: "2rem"}}/>
                          </IconButton>
                        </a>
                      </Box>
                      </div>
                      </Box>
                      
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {!smallSize && (
                <Grid item xs={2} className="toc-bar-wrapper">
                  <div className="toc-bar">
                    <List
                      component="nav"
                      aria-label={tocs.map((toc) => toc.text).join(' ')}
                    >
                      {tocs.map((toc, i) => {
                        return (
                          <HashLink
                            to={`#${toc.href}`}
                            className={`toc-item ${
                              toc_active === i && 'active'
                            }`}
                            key={toc.text}
                          >
                            <ListItem button>
                              <ListItemText
                                className="toc-text"
                                primary={toc.text}
                              />
                            </ListItem>
                          </HashLink>
                        );
                      })}
                    </List>
                  </div>
                </Grid>
              )}
              <Grid item xs={smallSize ? 12 : 10}>
                <Content />
              </Grid>
              {smallSize && <Grid item xs={2}></Grid>}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </HomeLayout>
  );
};

export default HomePage;
